import React from 'react'
import { connect } from 'react-redux'
import { getEmployments, getLoanApplicationId, getEmploymentIds } from '../../../reducers'
import { employmentChanged, buildEmployment, updateEmploymentsStart } from '../../../actions'
import { presenceErrorClass } from 'servos/formValidations'

import LinkedInCard from './LinkedInCard'
import HistoryCard from './HistoryCard'
import ActionButtons from '../../commons/ActionButtons'

class Employment extends React.Component {

  handleNewInput = () => {
    this.setState({ validationReset: true })
    this.setState({ continueButtonEnabled: true })
  }

  // TODO: change setState of linkedInEnabled when we have linkedin
  componentDidMount() {
    window.scrollTo({top: 0})

    if (this.props.employmentIds.length === 0) {
      this.onNewEmploymentClick()
    } else {
      this.setState({ linkedInEnabled: false })
    }
  }

  componentDidUpdate() {
    if (this.props.employmentIds.length === 0) {
      this.onNewEmploymentClick()
    }
  }

  state = {
    // Set this state to false until we have linked in set up
    // https://trello.com/c/mOyB1Ebj
    linkedInEnabled: false,
    errors: {},
    continueButtonEnabled: true,
    validationReset: false
  }

  onContinueClick = () => {
    this.props.updateEmploymentsStart()
  }

  continueEnabled() {
    if (this.state.linkedInEnabled) {
      return false
    }

    return this.props.employmentIds.length > 0
  }

  // skip linkedin. update credit sense report enable to false
  onSkipClick = () => {
    this.setState({ linkedInEnabled: false })
  }

  onNewEmploymentClick = () => {
    let key = Date.now() + parseInt(Math.random()*100)
    this.props.buildEmployment({
      key: key,
      data: {
        key,
      }
    })
  }

  renderHistoryCard() {
    const { employmentIds } = this.props

    return employmentIds.map((id, index) => (
      <HistoryCard
        id={id}
        key={id}
        index={(index + 1)}
        employmentIds={employmentIds}
        onNewEmploymentClick={this.onNewEmploymentClick}
        occupations={this.props.availableOccupations}
        employmentType={this.props.availableEmploymentType}
        resetValidation={this.handleNewInput}
      />
    ))
  }

  render() {
    const {
      linkedInEnabled,
      errors,
      continueButtonEnabled
    } = this.state

    return (
      <div>
        <h3>{this.props.name}'s Employment</h3>
        <p className='grey big.mb-4'>We require
          information about your current employment and industry experience.</p>
        { linkedInEnabled ?
            <LinkedInCard
              onSkipClick={this.onSkipClick}
            /> :
            <div>
              { this.renderHistoryCard() }
              <div className='card card-single'>
                <div className='card-body'>
                  <div className={`invalid-feedback-alert ${presenceErrorClass(errors['employmentHistory'])}`}>
                    { errors['employmentHistory'] }
                  </div>
                  <div className='card card-border card-btn card-add mt-1' onClick={this.onNewEmploymentClick}>
                    <div className="media mt-1 mb-1">
                      <div className="media-body">
                        Add another job
                      </div>
                      <div className="align-self-center btn-icon">
                        <div className='material-icons'>
                          add_circle_outline
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        }
        <br />
        <br />
        <ActionButtons
          continueEnabled={ this.continueEnabled() && continueButtonEnabled }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  employments: getEmployments(state),
  employmentIds: getEmploymentIds(state),
  loanApplicationId: getLoanApplicationId(state)
})

export default connect(mapStateToProps, {
  employmentChanged,
  buildEmployment,
  updateEmploymentsStart
})(Employment)
